<template>
  <div
    class="page-activity container"
    :data-cms="activity._moduleId"
    :style="{ 'background-color': activity.backgroundColor }"
  >
    <div v-if="loading" class="loading">
      <a-spin size="large"></a-spin>
    </div>
    <template v-else>
      <div
        class="mod-banner"
        :style="{ height: activity.banner?.height + 'px' }"
      >
        <div
          class="wrapper"
          :style="{
            'margin-left': -activity.banner?.width / 2 + 'px',
            height: activity.banner.height + 'px',
            width: activity.banner?.width + 'px',
          }"
        >
          <img
            :src="activity.banner.image"
            :style="{
              height: activity.banner.height + 'px',
              width: activity.banner.width + 'px',
            }"
            alt="banner"
          />
          <a
            class="anchor"
            v-for="(anchor, index) in activity.banner?.map"
            :key="index"
            :href="anchor.url"
            :target="anchor.target"
            :title="anchor.title"
            :style="{
              top: anchor.top + 'px',
              left: anchor.left + 'px',
              height: anchor.height + 'px',
              width: anchor.width + 'px',
            }"
          ></a>
        </div>
      </div>
      <div
        class="mod-floors"
        :style="{ width: activity.floors?.[0]?.floor?.width + 'px' }"
      >
        <div
          class="floor"
          v-for="(floor, floorIndex) in activity.floors"
          :key="floorIndex"
          :style="{ height: floor.floor?.height + 'px' }"
          :id="floor.id"
        >
          <img class="lazyload" v-imgLazy="floor.floor?.image" />
          <a
            class="anchor"
            v-for="(anchor, anchorIndex) in activity.banner?.map"
            :key="anchorIndex"
            :href="anchor.url"
            :target="anchor.target"
            :title="anchor.title"
            :style="{
              top: anchor.top + 'px',
              left: anchor.left + 'px',
              height: anchor.height + 'px',
              width: anchor.width + 'px',
            }"
          ></a>
        </div>
      </div>
      <div class="mod-content" v-html="activity?.content" :style="{ width: activity.floors?.[0]?.floor?.width + 'px' }"></div>
    </template>
  </div>
</template>

<script>
import './index'
import imgLazy from '@/directives/imgLazy.js'

export default {
  data () {
    return {
      loading: true,
      activity: {}
    }
  },
  directives: {
    imgLazy: imgLazy
  },
  created () {
    const { id } = this.$route.params

    if (!id) {
      this.$message.error('抱歉，找不到活动，即将返回首页', () => {
        this.$router.replace('/')
      })
    }

    this.fetch(id)
  },
  methods: {
    async fetch (id) {
      try {
        const data = await window.__MICRO_ROOT__.cms.fetchPageData(id)
        if (data) {
          this.activity = data.content
          this.loading = false
        }
      } catch (err) {
        this.loading = false
        this.$message.error(
          err.message || '抱歉，找不到活动，即将返回首页',
          () => {
            this.$router.replace('/')
          }
        )
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-activity {
  min-height: 300px;
  width: 100%;
  overflow: hidden;
  .anchor {
    position: absolute;
  }
  .loading {
    padding: 200px 0;
    text-align: center;
  }
}
.mod-banner {
  position: relative;
  overflow: hidden;
  .wrapper {
    position: absolute;
    top: 0;
    left: 50%;
  }
}
.mod-floors {
  margin: 0 auto;
  .floor {
    position: relative;
  }
}
.mod-content {
  margin: 0 auto;
  padding: 20px 0;
}
.mod-sidebar {
  position: fixed;
  top: 50%;
  right: 10px;
  z-index: 1000;
  .anchor {
    cursor: pointer;
  }
}
</style>
